export {AuthorizedArea} from './AuthorizedArea';
